var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-relative tw-inline-block tw-z-50",on:{"mouseenter":_setup.handleMouseEnter,"mouseleave":_setup.handleMouseLeave,"click":_setup.handleClick}},[_vm._t("default"),_vm._v(" "),_c('div',{class:[
      'tw-absolute tw-p-1.5 tw-pointer-events-none',
      _setup.side, _setup.shift, _setup.translate,
      _setup.display,
      _setup.visible ? 'tw-opacity-100' : 'tw-opacity-0',
      'tw-transition-opacity',
    ]},[_c('div',{class:[
        'tw-px-2.5 tw-py-1.5 tw-rounded tw-shadow',
        _vm.label ? `${_vm.bgColor} tw-text-white tw-text-sm tw-font-normal tw-normal-case tw-tracking-normal` : '',
        _vm.label?.length > 50 ? 'tw-w-80' : 'tw-whitespace-nowrap',
        _vm.tooltipClasses,
      ]},[_vm._t("content",function(){return [_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")]})],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }